import {Injectable} from '@angular/core';

export enum QuestionTypeEnum {

  check = 1,
  radio = 2,
  combo = 3,
  text = 4,
  picture = 5,
  email = 6,
  video = 7,
  signature = 8,
  audio = 9,
  background = 10,
  photoText = 11,
  photoBundle = 12,
  vimeo = 14,
  dynamic = 15,
  sms = 16
}
// TODO: redundant fix it later.
@Injectable()
export class  QuestionTypeEnumUtil {

  constructor() {}
  static getType(type:string):QuestionTypeEnum {
    switch(type) {
      case 'check': return QuestionTypeEnum.check;
      case 'radio': return QuestionTypeEnum.radio;
      case 'combo':return QuestionTypeEnum.combo;
      case 'text':return QuestionTypeEnum.text;
      case 'picture': return QuestionTypeEnum.picture;
      case 'email': return QuestionTypeEnum.email;
      case 'video':return QuestionTypeEnum.video;
      case 'signature':return QuestionTypeEnum.signature;
      case 'audio': return QuestionTypeEnum.audio;
      case 'background': return QuestionTypeEnum.background;
      case 'photoText':return QuestionTypeEnum.photoText;
      case 'photoBundle':return QuestionTypeEnum.photoBundle;
      case 'vimeo': return QuestionTypeEnum.vimeo;
      case 'dynamic':return QuestionTypeEnum.dynamic;
      case 'sms': return QuestionTypeEnum.sms;
    }

  }

}
